module.exports = __webpack_public_path__ + "assets/img/title_5.1a3c2e2a.png";